import { useEffect, useState } from "react";
import { ContactBlock, ContactSection, ContactSubTitle, ContactTitle, Form, ImgLinkBlock, Input, MiniButtonLink, StyledButton, StyledContainer, StyledLoadingElement, StyledTitle, TextArea, WarningText } from "./styled";
import useSendEmail from "./useSendEmail";
import { ReactComponent as Inst } from "./img/inst.svg";
import { ReactComponent as Face } from "./img/face.svg";
import { ReactComponent as Tel } from "./img/tel.svg";
import { contacts } from "../../../settings";

const Contact = () => {
    const { send, initialEmailData, isLoading, statusMsg, isSuccess } = useSendEmail();
    const [emailData, setEmailData] = useState(initialEmailData);

    const handlerInput = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, data: string) => {
        setEmailData({ ...emailData, [data]: e.currentTarget.value });
    };

    useEffect(() => {
        setEmailData(initialEmailData);
    }, [isSuccess, initialEmailData])

    return (
        <StyledContainer id="contact">
            <ContactSection>
                {/* <ContactBlock>
                    <ImgLinkBlock href={`mailto:${contacts.email}`}><Mail /></ImgLinkBlock>
                    <ContactTitle>Email</ContactTitle>
                    <ContactSubTitle>{contacts.email}</ContactSubTitle>
                    <MiniButtonLink href={`mailto:${contacts.email}`}>Запишись</MiniButtonLink>
                </ContactBlock> */}
                <ContactBlock>
                    <ImgLinkBlock target="_blank" href={contacts.instagramLink}><Inst /></ImgLinkBlock>
                    <ContactTitle>Instagram</ContactTitle>
                    <ContactSubTitle>{contacts.instagramName}</ContactSubTitle>
                    <MiniButtonLink target="_blank" href={contacts.instagramLink}>Запишись</MiniButtonLink>
                </ContactBlock>
                <ContactBlock>
                    <ImgLinkBlock target="_blank" href={contacts.facebookLink}><Face /></ImgLinkBlock>
                    <ContactTitle>Facebook</ContactTitle>
                    <ContactSubTitle>{contacts.facebookName}</ContactSubTitle>
                    <MiniButtonLink target="_blank" href={contacts.facebookLink}>Запишись</MiniButtonLink>
                </ContactBlock>
                <ContactBlock>
                    <ImgLinkBlock href={`tel:${contacts.phoneNumber}`}><Tel /></ImgLinkBlock>
                    <ContactTitle >tel</ContactTitle>
                    <ContactSubTitle>{contacts.phoneNumber}</ContactSubTitle>
                    <MiniButtonLink href={`tel:${contacts.phoneNumber}`}>Запишись</MiniButtonLink>
                </ContactBlock>
            </ContactSection>
            <StyledTitle>Маєш питання?</StyledTitle>
            {
                isLoading
                    ? <StyledLoadingElement />
                    : <WarningText>{statusMsg}</WarningText>
            }
            <Form onSubmit={(e) => send(e, emailData)}>
                <Input
                    required
                    type="text"
                    value={emailData.name}
                    placeholder="Name"
                    onChange={(e) => handlerInput(e, "name")}
                />
                <Input
                    required
                    type="text"
                    value={emailData.surname}
                    placeholder="Surname"
                    onChange={(e) => handlerInput(e, "surname")}
                />
                <Input
                    required
                    type="email"
                    pattern="\b[\w\.-]+@[\w\.-]+\.\w{2,5}\b"
                    value={emailData.email}
                    placeholder="Email"
                    onChange={(e) => handlerInput(e, "email")}
                />
                <Input
                    required
                    type="tel"
                    value={emailData.tel}
                    placeholder="Phone number"
                    onChange={(e) => handlerInput(e, "tel")}
                />
                <TextArea
                    required
                    value={emailData.message}
                    placeholder="Message"
                    onChange={(e) => handlerInput(e, "message")}
                />
                <StyledButton disabled={isSuccess}>Відправити</StyledButton>
            </Form>
        </StyledContainer>
    );
};

export default Contact;